import {gql} from '@apollo/client';
import {Col, Empty, Row, Skeleton} from 'antd';
import {useParams} from 'react-router-dom';
import {Address, Artists, Arts} from 'src/components';
import {GqlArtistFragment} from 'src/components/Artists';
import {GqlArtFragment} from 'src/components/Arts';
import {useQuery} from 'src/hooks';
import {QueryProfileShow} from './__generated__/QueryProfileShow';

const QUERY = gql`
  query QueryProfileShow($address: ID!) {
    player(id: $address) {
      id
      artists {
        ...ArtistFragment
      }
      arts {
        ...ArtFragment
      }
    }
  }
  ${GqlArtistFragment}
  ${GqlArtFragment}
`;

export default function ProfileShow(): JSX.Element {
  const {address} = useParams<{address: string}>();
  const {data, loading} = useQuery<QueryProfileShow>(QUERY, {
    variables: {address: address.toLowerCase()},
    fetchPolicy: 'cache-and-network',
  });

  const artists = data?.player?.artists || [];
  const arts = data?.player?.arts || [];

  return (
    <Skeleton loading={loading} active={loading}>
      <h1>
        <Address address={address} />
      </h1>
      <Row gutter={[50, 50]}>
        <Col xs={24} md={12}>
          <h2>Artists</h2>
          {artists.length > 0 ? (
            <Artists artists={artists} maxColumns={3} />
          ) : (
            <Empty description='No artists owned' />
          )}
        </Col>
        <Col xs={24} md={12}>
          <h2>Arts</h2>
          {arts.length > 0 ? (
            <Arts arts={arts} showExtraInfo={false} maxColumns={3} />
          ) : (
            <Empty description='No art owned' />
          )}
        </Col>
      </Row>
    </Skeleton>
  );
}
